import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { selectFacility } from '@AMIEWEB/Facility/FacilityStore/Facility.selector';
import { selectOrderDetailsOrderType } from '@AMIEWEB/Order/Store/Order.selectors';
import { AMNDivisionType } from 'app/models/enums/AMNDivisionType';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const OrderType = () => {
  const { t } = useTranslation();
  const orderTypes = useSelector(selectOrderDetailsOrderType);
  const { control, setValue, register } = useFormContext();
  const facilityDetails = useSelector(selectFacility);
  const [disable, setDisable] = useState<boolean>(false);
  const orderType = useWatch({ name: 'orderType' });
  register('orderTypeId');

  useEffect(() => {
    facilityDetails?.facilityResponse?.amnDivisionTypeId === AMNDivisionType.hsg ? setDisable(true) : setDisable(false);
  }, [facilityDetails, setDisable]);

  return (
    <Controller
      control={control}
      name={'orderType'}
      rules={{ required: true }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          name={'orderType'}
          label={`${t('order.newOrderCreation.tabs.orderTypeDetail.orderType')} ${t('*')}`}
          require={true}
          standard={true}
          disabled={disable}
          inputValue={orderType ?? null}
          options={orderTypes ?? []}
          isOrderCreationElement={true}
          handleChange={e => {
            onChange(e);
            setValue('orderTypeId', orderTypes.find(item => item.Description === e.target.value)?.ID, { shouldValidate: true });
          }}
          showErrorAttribute={value ? false : true}
        />
      )}
    />
  );
};
